const datasetDetailPanel = {
  meta: {
    rows: "Rows",
    columns: "Columns",
    pseudonymized: "Pseudonymized",
    pseudonymizedRatio: "{{count}} of {{total}}",
    created: "Created",
    expires: "Expires",
    noExpiry: "Never",
  },
  columnsSectionLabel: "Columns",
  selectRowHint: "— select a row for its summary statistics",
  table: {
    column: "Column",
    type: "Type",
    sensitivity: "Sensitivity",
    complete: "Complete",
  },
  pseudonymizedBadge: "Pseudonymized",
  pseudonymizedBadgeTitle:
    "Originally personal data ({{column}}) — values shown are generated pseudonyms, not the original data",
  stats: {
    min: "Min",
    max: "Max",
    mean: "Mean",
    median: "Median",
    stdDev: "Std dev",
  },
  categories: "Categories ({{count}})",
  moreCategories: "+{{count}} more",
  uniqueValues_one: "{{formatted}} unique value",
  uniqueValues_other: "{{formatted}} unique values",
  uniqueNoExposure: "— counted without exposing the originals",
  emptyCount: "· {{formatted}} empty",
  legend:
    "Pseudonymized — this column originally held personal data; values were replaced with a generated pseudonym before the file entered the catalog.",
};

export default datasetDetailPanel;
